// extracted by mini-css-extract-plugin
export var phone = "_1k-0";
export var phoneDragging = "_1k-1";